import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ActionDlg } from '../../../../general/dialogs/action-dlg';
import { gotoClientPortal } from '../../../../store/actions/route';
import { authorizeWithOtpSuccess } from '../../reducer/session';

type Props = {
  onClose: () => void;
};

const UserWithEmailAndPhoneExistsDlg: FC<Props> = ({ onClose }: Props) => {
  const dispatch = useDispatch();

  const handleContinue = useCallback(() => {
    onClose();
    dispatch(authorizeWithOtpSuccess());
  }, [onClose, dispatch]);

  const handleSignIn = useCallback(() => {
    onClose();
    dispatch(gotoClientPortal());
  }, [onClose, dispatch]);

  return (
    <ActionDlg
      content={<>It looks like you already have a Coast account. Do you want to apply for another Coast account?</>}
      title="You Already Have a Coast Account"
      primaryActionLabel="Apply for a New Coast Account"
      secondaryActionLabel="Sign in to Existing Account"
      onPrimaryAction={handleContinue}
      onSecondaryAction={handleSignIn}
      onClose={onClose}
    />
  );
};

export { UserWithEmailAndPhoneExistsDlg };
